<template>
    <div class="container-fluid">

        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Suporte
                        </h6>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4 col-lg-4 col-sm-12">
                                <div class="card shadow-sm max-height-limit">
                                    <div class="card-header bg-primary text-white font-weight-bold">
                                        Tickets
                                    </div>
                                    <ul class="nav nav-tabs mt-2" id="myTab" role="tablist">
                                        <li class="nav-item" style="width: 50%;">
                                            <a class="nav-link active" id="open-tab" data-toggle="tab" href="#open"
                                                role="tab" aria-controls="open" aria-selected="true" @click="openTab">Abertos</a>
                                        </li>
                                        <li class="nav-item" style="width: 50%;">
                                            <a class="nav-link" id="close-tab" data-toggle="tab" href="#close"
                                                role="tab" aria-controls="close" aria-selected="false" @click="openTab">Encerrados</a>
                                        </li>
                                    </ul>
                                    <div class="tab-content" id="myTabContent">
                                        <div class="tab-pane fade show active" id="open" role="tabpanel"
                                            aria-labelledby="open-tab">
                                            <div class="list-group list-group-flush overflow-auto"
                                                style="min-height: 500px;max-height: 500px;">
                                                <a href="#" v-for="(ticket, index) in ticket_opened" :key="index"
                                                    @click="openMessageTicket('open', ticket, index)"
                                                    class="list-group-item list-group-item-action py-1 z-index-1"
                                                    :class="ticket_opened_selected == index ? 'active' : ''">
                                                    <p class="small badge badge-info mt-2">{{ ticket.subject }}</p>
                                                    <div
                                                        class="d-flex w-100 justify-content-between align-items-center">
                                                        <h6 class="mb-2">{{ ticket.user }}</h6>
                                                    </div>
                                                    <p class="small">Protocolo nº: {{ ticket.protocol }}</p>
                                                    <p class="small mt-n3 mb-1">Aberto em: {{ ticket.created_at_date }}
                                                        às {{ ticket.created_at_hour }}</p>

                                                </a>
                                                <p class="text-center mt-5" v-if="ticket_opened.length <= 0">Nenhum
                                                    ticket em aberto no momento...</p>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="close" role="tabpanel"
                                            aria-labelledby="close-tab">
                                            <div class="list-group list-group-flush overflow-auto"
                                                style="min-height: 500px;max-height: 500px;">
                                                <a href="#" v-for="(ticket, index) in ticket_close" :key="index"
                                                    @click="openMessageTicket('close', ticket, index)"
                                                    class="list-group-item list-group-item-action py-1 z-index-1"
                                                    :class="ticket_close_selected == index ? 'active' : ''">
                                                    <p class="small badge badge-info mt-2">{{ ticket.subject }}</p>
                                                    <div
                                                        class="d-flex w-100 justify-content-between align-items-center">
                                                        <h6 class="mb-2">{{ ticket.user }}</h6>
                                                    </div>
                                                    <p class="small">Protocolo nº: {{ ticket.protocol }}</p>
                                                    <p class="small mt-n3 mb-1">Aberto em: {{ ticket.created_at_date }}
                                                        às {{ ticket.created_at_hour }}</p>

                                                </a>
                                                <p class="text-center mt-5" v-if="ticket_close.length <= 0">Nenhum
                                                    ticket encerrado no momento...</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8 col-lg-8 col-sm-12 d-none d-md-block">
                                <div class="card shadow-sm">
                                    <div class="card-header bg-white border-bottom" v-if="ticket != null">
                                        <div class="row">
                                            <div class="col-lg-8 col-md-8 col-sm-12">
                                                <div class="d-flex">
                                                    <div class="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                                                        style="width: 40px; height: 40px;">
                                                        <strong>{{ this.name_chat.slice(0, 2) }}</strong>
                                                    </div>
                                                    <div class="ml-3">
                                                        <h6 class="mb-0">{{ this.name_chat }}</h6>
                                                        <small class="text-success">#Protocolo {{ ticket.protocol
                                                            }}</small>
                                                        <div class="ml-3 badge"
                                                            :class="ticket.status == 'Finalizado' ? 'badge-success' : 'badge-danger'">
                                                            {{ ticket.status }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12">
                                                <div class="btn-group float-right" role="group" v-if="ticket != null && ticket.status == 'Aberto'" >
                                                    <button id="btnGroupDrop1" type="button"
                                                        class="btn btn-danger dropdown-toggle" data-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        Ações
                                                    </button>
                                                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                        <a class="dropdown-item" href="#" @click="stopTicket">Encerrar
                                                            ticket</a>
                                                    </div>
                                                </div>
                                                <div class="btn-group float-right" role="group" v-else >
                                                    <button id="btnGroupDrop1" type="button" disabled
                                                        class="btn btn-danger dropdown-toggle" data-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        Ações
                                                    </button>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-body bg-light" style="height: 400px; overflow-y: auto;"
                                        ref="chatContent">
                                        <div v-for="(msg, index) in messages" :key="index">
                                            <div class="d-flex justify-content-start mb-4"
                                                :class="msg.agent == 'user' ? 'justify-content-start' : 'justify-content-end'">
                                                <div class="msg-container p-3 shadow-sm"
                                                    :class="msg.agent == 'bot' ? 'bg-default' : 'bg-success'"
                                                    style="max-width: 75%; border-radius: 0 15px 15px 15px;">
                                                    <p class="mb-1 small">{{ msg.message }}</p>
                                                    <div class="text-right">
                                                        <small class="text-black" style="font-size: 0.7rem;">{{
                                                            msg.created_at_date }} às {{ msg.created_at_hour }}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                         <div v-if="ticket != null && ticket.status == 'Finalizado'">
                                                <p class="text-center ticket-stop">Este ticket foi encerrado!</p>
                                         </div>
                                        <div class="card h-100 d-flex align-items-center justify-content-center bg-light"
                                            v-if="messages.length <= 0">
                                            <p class="text-muted">Selecione uma conversa para ler as mensagens.</p>
                                        </div>
                                    </div>
                                    <div class="input-group-append  border-top " v-if="ticket != null">
                                        <form @submit.prevent="enviarMensagem" class="width100">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <button type="button" class="btn btn-light border-0"
                                                        @click="triggerFile">
                                                        <i class="fas fa-paperclip text-muted" :disabled="input_text || ticket.status == 'Finalizado'"></i>
                                                    </button>
                                                </div>

                                                <input type="file" ref="fileInput" @change="anexarArquivo"
                                                    style="display: none">

                                                <input v-model="novoTexto" type="text"
                                                    class="form-control border-0 bg-light" placeholder="Escreva aqui..."
                                                    :disabled="input_text || ticket.status == 'Finalizado'"
                                                    style="height: 50px;background: #fff!important;">

                                                <div class="input-group-append">
                                                    <button class="btn btn-primary" type="submit">
                                                        <i class="fas fa-paper-plane" :disabled="input_text || ticket.status == 'Finalizado'"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { notify } from "@kyvg/vue3-notification";

export default {
    name: 'ChatContainer',
    data() {
        return {
            user: null,
            ticket_opened: [],
            ticket_close: [],
            ticket: null,
            messages: [],
            ticket_protocol_open: '',
            novoTexto: '',
            name_chat: '',
            ticket_opened_selected: 0,
            ticket_close_selected: 0,
            loadAutomaticTickers:false

        };
    },
    mounted() {
        this.searchTickets();
    },
    methods: {

        processMessages(messages) {
            messages.forEach(message => {
                this.messages.push(message);
            });
        },

        searchTickets() {
            api.get('/tickets')
                .then((response) => {
                    this.loading = false;
                    let tickets = response.data.data;
                    tickets.forEach(ticket => {
                        if (ticket.status == 'Aberto') {
                            this.ticket_opened.push(ticket);
                        } else {
                            this.ticket_close.push(ticket);
                        }
                        if(!this.loadAutomaticTickers){
                            console.log('ok');
                            this.loadAutomaticTickers = true;
                            this.loadAutomaticTickets();
                        }
                        
                    });
                }).catch(error => {
                    this.loading = false;
                    if (error.status == 429) {
                        notify({
                            title: "Falha",
                            text: "Desculpe-nos, mas estamos indisponíveis no momento. Por gentileza, tente novamente em instantes. Cód 429",
                            type: 'error'
                        });
                    } else if (error.status == 500) {
                        notify({
                            title: "Falha",
                            text: "Desculpe-nos, mas não estamos conseguindo verificar os tickets no momento. Por favor, tente novamente em instantes. Cód 500",
                            type: 'error'
                        });
                    }

                })
        },

        searchProtocol(protocol) {
            //Busca informação banco de dados
            api.get('/search-protocol/' + protocol)
                .then((response) => {
                    this.loading = false;
                    if (response.data.data.status == 'Finalizado') {
                        this.input_text = true;
                    } else {
                        this.input_text = false;
                        let messages = response.data.data.messages;
                        this.messages = [];
                        this.processMessages(messages);
                    }
                    this.scrollToBottom();
                }).catch(error => {
                    this.loading = false;
                    if (error.status == 404) {
                        this.injectMessage('bot', 'Desculpe-nos, mas não conseguimos identificar  o protocolo. Por gentileza, poderia verificar se informou corretamente os números, no padrão <strong>xxxx-xxxxxx</strong>');
                    } else if (error.status == 429) {
                        this.injectMessage('bot', 'Desculpe-nos, mas estamos indisponíveis no momento. Por gentileza, tente novamente em instantes. Cód 429');
                    } else if (error.status == 500) {
                        this.injectMessage('bot', 'Desculpe-nos, mas não estamos conseguindo verificar seu registro no momento. Por favor, tente novamente em instantes. Cód 500');
                    }
                    this.scrollToBottom();
                })
        },

        loadNewMessages() {

            this.polling = setInterval(() => {
                if (this.ticket_protocol_open != null) {
                    this.searchProtocol(this.ticket_protocol_open);
                }

            }, 60000);
        },

        loadAutomaticTickets() {

            this.polling_ticket = setInterval(() => {
                if (this.loadAutomaticTickers) {
                    this.searchTickets();
                }

            }, 500000);
        },

        openMessageTicket(type, ticket, ticket_selected) {
            this.ticket = ticket;
            this.ticket_protocol_open = ticket.protocol;
            this.messages = ticket.messages;
            this.name_chat = this.ticket.user;
            if (type == 'open') {
                this.ticket_opened_selected = ticket_selected;
            } else {
                this.ticket_close_selected = ticket_selected;
            }
            this.loadNewMessages();
            this.scrollToBottom();
        },
        enviarMensagem() {
            if (this.novoTexto.trim() === '') return;

            let message = this.novoTexto.trim();
            api.post('/register-message/' + this.ticket.protocol, {
                'type': 'text',
                'message': message,
                'agent': 'bot'

            })
                .then((response) => {
                    this.messages.push(response.data.data);
                    this.novoTexto = '';
                    this.loadNewMessages();
                    this.scrollToBottom();
                }).catch(error => {
                    this.loading = false;
                    if (error.status == 404) {
                        this.injectMessage('bot', 'Desculpe-nos, mas não conseguimos identificar seu cadastro. Por gentileza, poderia verificar se informou corretamente o documento?');
                    } else if (error.status == 429) {
                        this.injectMessage('bot', 'Desculpe-nos, mas estamos indisponíveis no momento. Por gentileza, tente novamente em instantes. Cód 429');
                    } else if (error.status == 500) {
                        this.injectMessage('bot', 'Desculpe-nos, mas não estamos conseguindo enviar a mensagem no momento. Por favor, tente novamente em instantes. Cód 500');
                    }
                    this.scrollToBottom();
                })
        },

        stopTicket() {
            this.$confirm(
                {
                    message: 'Deseja encerrar o ticket?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('/close-protocol/' + this.ticket.protocol)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Ticket encerrado com sucesso",
                                        type: 'success'
                                    });
                                     this.messages = [];
                                     this.ticket_opened = [];
                                     this.ticket_close = [];
                                     this.searchTickets();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        openTab(){
            this.messages = [];
            this.ticket = null;
        },

        scrollToBottom() {
            // O nextTick garante que o DOM foi atualizado antes de rolar
            this.$nextTick(() => {
                const container = this.$refs.chatContent;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        },
         beforeUnmount() {
            this.ticket_protocol_open = null;
            this.loadAutomaticTickers = false;
         }
    }
};
</script>

<style scoped>
.max-height-limit {
    max-height: 400px;
    /* Or 100vh for viewport height */
    overflow-y: auto;
    /* Or just 'overflow: auto;' */
    scroll-behavior: smooth;
}

.z-index-1 {
    z-index: 1;
}

.width100 {
    width: 100%;
}

.float-right {
    float: right !important;
}

.ticket-stop{
    background: #ebebeb;
    border: 1px dotted #000;
    border-radius: 10px;
    padding:10px;
    box-shadow: 1px 1px 1px #000;
}
</style>